import AddMultipleAssigneeDropdown from 'components/CustomDropdown/AddMultipleAssigneeDropdown';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ButtonTextLoader from '../../../components/Loaders/ButtonTextLoader';
import { PrimaryButton } from '../../../styledComponents/buttons';
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
  FormAlert,
  InputField,
  InputLabel,
  InputWithLabelSection,
  RedStar,
} from '../../../styledComponents/common';
import { checkHtml, checkUrl } from '../../../utils/helper';
import { InfoSection } from '../officesStyles';

const OfficeDetails = ({
  handleChangePage,
  officeDetails,
  // api and reducer
  createOffice,
  updateOffice,
  addOrUpdateOfficeLoading,
  officeCreateUpdateSuccess,

  clearOfficeDetails,

  toggleDeleteModal,
  getMonazimList,
  monazimList,
  createdOffice,
  addOfficeAssignee,
  removeOfficeAssignee,
  isAssigneesLoading,
}) => {
  const { t } = useTranslation();

  const [officeName, setOfficeName] = useState('');
  const [officeCode, setOfficeCode] = useState('');

  const [saveErrors, setSaveErrors] = useState({});

  const [action, setAction] = useState('add');
  const [selectedAssignees, setSelectedAssignees] = useState();

  const handleAssignMember = member => {
    officeDetails?.id &&
      !isAssigneesLoading &&
      addOfficeAssignee({ office_id: officeDetails.id, user_id: member.id });
  };
  const handleRemoveMember = member => {
    officeDetails?.id &&
      removeOfficeAssignee({
        office_id: officeDetails.id,
        assignee_id: member.id,
      });
  };

  const clearStateAndProps = () => {
    clearOfficeDetails();
    setOfficeName('');
    setOfficeCode('');
    setAction('add');
  };

  useEffect(() => {
    return () => {
      clearStateAndProps();
    };
  }, []);

  useEffect(() => {
    if (officeCreateUpdateSuccess) {
      clearStateAndProps();
      createdOffice
        ? handleChangePage('details', createdOffice)
        : handleChangePage('list');
    }
  }, [officeCreateUpdateSuccess]);

  useEffect(() => {
    if (officeDetails && officeDetails.id) {
      setAction('update');
      setOfficeName(officeDetails.name);
      setOfficeCode(officeDetails.code);
      getMonazimList();
    }
  }, [officeDetails]);
  useEffect(() => {
    if (officeDetails?.monazim) {
      setSelectedAssignees(
        officeDetails.monazim.map(assignee => {
          return {
            ...assignee,
            name: assignee.first_name + ' ' + assignee.last_name,
          };
        }),
      );
    } else setSelectedAssignees([]);
  }, [officeDetails?.monazim]);

  const checkError = () => {
    let saveErrors = {};
    let formIsValid = true;

    if (checkUrl(officeName)) {
      formIsValid = false;
      saveErrors['name'] = 'Office name can not contain url';
    } else if (checkHtml(officeName)) {
      formIsValid = false;
      saveErrors['name'] = 'Invalid office name';
    }
    if (checkUrl(officeCode)) {
      formIsValid = false;
      saveErrors['code'] = 'Office code can not contain url';
    } else if (checkHtml(officeCode)) {
      formIsValid = false;
      saveErrors['code'] = 'Invalid office code';
    }
    setSaveErrors(saveErrors);
    return formIsValid;
  };

  const handleAddOrUpdateOffice = () => {
    if (checkError()) {
      const payload = {
        name: officeName,
        code: officeCode,
      };

      if (action === 'update' && officeDetails && officeDetails.id) {
        payload.office_id = officeDetails.id;
        updateOffice(payload);
      } else {
        createOffice(payload);
      }
    }
  };

  const onOfficeNameChange = e => {
    let errors = { ...saveErrors };
    delete errors['name'];
    setSaveErrors(errors);
    setOfficeName(e.target.value);
  };

  const onOfficeCodeChange = e => {
    let errors = { ...saveErrors };
    delete errors['code'];
    setSaveErrors(errors);
    setOfficeCode(e.target.value);
  };

  return (
    <CommonFlex gap="20px" direction="column" padding="20px" alignItems="start">
      <CommonText name title fontSize="16px" margin="0">
        {t('add_office_details')}
      </CommonText>
      <CommonFlex gap="20px" direction="column" alignItems="start">
        <InputWithLabelSection width="100%">
          <InputLabel>
            {t('office_name')}
            <RedStar>*</RedStar>
          </InputLabel>
          <InputField
            type="text"
            placeholder={t('type_office_name')}
            value={officeName}
            onChange={e => onOfficeNameChange(e)}
            error={
              saveErrors &&
              saveErrors['name'] &&
              saveErrors['name'] !== undefined
            }
          />
          {saveErrors &&
            saveErrors['name'] &&
            saveErrors['name'] !== undefined && (
              <FormAlert margin="0 0 0 5px">{saveErrors['name']}</FormAlert>
            )}
        </InputWithLabelSection>

        <InputWithLabelSection width="100%">
          <InputLabel>
            {t('office_code')}
            <RedStar>*</RedStar>
          </InputLabel>
          <InputField
            type="text"
            placeholder={t('type_office_code')}
            value={officeCode}
            onChange={e => onOfficeCodeChange(e)}
            error={
              saveErrors &&
              saveErrors['code'] &&
              saveErrors['code'] !== undefined
            }
          />
          {saveErrors &&
            saveErrors['code'] &&
            saveErrors['code'] !== undefined && (
              <FormAlert margin="0 0 0 5px">{saveErrors['code']}</FormAlert>
            )}
        </InputWithLabelSection>

        <PrimaryButton
          width="100%"
          margin="20px 0 0"
          disabled={!officeName.trim() || !officeCode.trim()}
          onClick={() => handleAddOrUpdateOffice()}
        >
          {addOrUpdateOfficeLoading ? (
            <ButtonTextLoader
              fontSize="14px"
              loadingText={
                action === 'update' ? t('update_office') : t('create_office')
              }
            />
          ) : action === 'update' ? (
            t('update_office')
          ) : (
            t('create_office')
          )}
        </PrimaryButton>
        {action === 'update' && (
          <CommonFlex direction="column" alignItems="start">
            <InputLabel>{t('assignees')}</InputLabel>
            <AddMultipleAssigneeDropdown
              numberOfVisibleMembers={8}
              isLoading={isAssigneesLoading}
              assigneesList={selectedAssignees}
              membersList={monazimList}
              handleAssign={handleAssignMember}
              handleRemove={handleRemoveMember}
              alwaysTop={true}
            />
          </CommonFlex>
        )}
      </CommonFlex>
    </CommonFlex>
  );
};

export default OfficeDetails;
